export default "__VITE_ASSET__CLhrnClP__"